"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerError = exports.onError = exports.emit = exports.listen = exports.removeListener = exports.removeAllListeners = void 0;
let listeners = {};
let errorCbs = [];
function removeAllListeners() {
    listeners = {};
    errorCbs = [];
}
exports.removeAllListeners = removeAllListeners;
function removeListener(event, cb) {
    if (!listeners[event]) {
        return;
    }
    const index = listeners[event].indexOf(cb);
    if (index === -1) {
        return;
    }
    listeners[event].splice(index, 1);
}
exports.removeListener = removeListener;
function listen(event, cb, once = false) {
    if (!listeners[event]) {
        listeners[event] = [];
    }
    if (once) {
        listeners[event].push(function runOnce(payload) {
            removeListener(event, runOnce);
            cb(payload);
        });
    }
    else {
        listeners[event].push(cb);
    }
}
exports.listen = listen;
function onError(cb) {
    errorCbs.push(cb);
}
exports.onError = onError;
function emit(event, payload) {
    if (!listeners[event]) {
        return;
    }
    listeners[event].forEach((cb) => {
        cb(payload);
    });
}
exports.emit = emit;
function triggerError(scope, error, payload = {}) {
    errorCbs.forEach((cb) => {
        cb({
            scope,
            error,
            payload,
        });
    });
}
exports.triggerError = triggerError;
